import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import formatter from '../../utilities/formatter';

const DesignerAnalysisItem = ({ item, totalRow }) => {

    return (totalRow ?
        (
            <tr className='total-row'>
                <td>
                    TOTAL
                </td>
                <td>
                    {item.appointmentsScheduled}
                </td>
                <td>
                    {item.installedJobs}
                </td>
                <td>
                    {formatter.percent(item.closingRate)}
                </td>
                <td>
                    {formatter.currency(item.installedSales)}
                </td>
                <td>
                    {formatter.percent(item.percentOfTotalSales)}
                </td>
                <td>
                    {formatter.currency(item.averageSale)}
                </td>
                <td colSpan={2}>
                    {formatter.currency(item.revenuePerLead)}
                </td>
            </tr>
        ) : (
        <tr>
            <CustomTd>
                {item.designer}
            </CustomTd>
            <CustomTd>
                {item.appointmentsScheduled}
            </CustomTd>
            <CustomTd>
                {item.installedJobs}
            </CustomTd>
            <CustomTd>
                {formatter.percent(item.closingRate)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.installedSales)}
            </CustomTd>
            <CustomTd>
                {formatter.percent(item.percentOfTotalSales)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.averageSale)}
            </CustomTd>
            <CustomTd colSpan={2}>
                {formatter.currency(item.revenuePerLead)}
            </CustomTd>
            </tr>
        )
    );
}

export default DesignerAnalysisItem;